<template>
  <div class="grid w-full grid-cols-2 justify-items-start bg-neutral-50 py-5 md:flex md:flex-row md:flex-nowrap">
    <div
      v-for="footerSection in cmsStore.footer?.sections"
      :key="footerSection.id"
      class="inline-flex flex-nowrap justify-center px-6 py-3 md:w-full"
    >
      <div class="flex flex-col flex-nowrap justify-start space-y-3">
        <UiHeading type="h3">{{ footerSection.heading }}</UiHeading>
        <UiLink
          v-for="footerLink in footerSection.links"
          :id="`footer-${footerLink.id}`"
          :key="footerLink.id"
          :underline="false"
          :to="`${footerLink.url}`"
          size="sm"
          class="text-neutral-600"
        >
          {{ footerLink.name }}
        </UiLink>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useCmsStore } from '~/stores/cms/cmsStore';

const cmsStore = useCmsStore();
</script>
